var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAngleBracket = function SvgAngleBracket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m6.943.334 1.414 1.413-6.352 6.351L.592 6.685z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.358 11.638-1.414 1.414L.57 6.678l1.414-1.414z"
  })));
};

export { SvgAngleBracket as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTIuNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjYuOTQzMzYiIHk9IjAuMzMzOTg0IiB3aWR0aD0iMS45OTg2NiIgaGVpZ2h0PSI4Ljk4MjQ3IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSA2Ljk0MzM2IDAuMzMzOTg0KSIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICA8cmVjdCB4PSI4LjM1NzQyIiB5PSIxMS42Mzg3IiB3aWR0aD0iMS45OTg2NiIgaGVpZ2h0PSI5LjAxMzU0IiB0cmFuc2Zvcm09InJvdGF0ZSgxMzUgOC4zNTc0MiAxMS42Mzg3KSIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";